import { Alert, Anchor, Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';
import { stringHelper } from '@zg-rentals/rental-manager-env';

type Props = {
  errors: Array<unknown>;
};

const DiscriminatoryContentErrorAlert = ({ errors }: Props) => {
  return (
    <Spacer marginY="sm">
      <Alert
        appearance="warning"
        body={
          <Text>
            {`${errors.length} of your captions does not comply with Zillow’s `}
            <Anchor href="https://www.zillow.com/z/info/good-neighbor-policy/" target="_blank">
              Good Neighbor Policy
            </Anchor>{' '}
            or{' '}
            <Anchor
              href="https://www.zillow.com/rental-manager/resources/zillow-respectful-renting-pledge/"
              target="_blank"
            >
              Respectful Renting Pledge
            </Anchor>{' '}
            Revise your {`${stringHelper.pluralizeWord(errors.length, 'caption', 'captions')}`} in order to save and
            publish it to your listing.
          </Text>
        }
      />
    </Spacer>
  );
};

export default DiscriminatoryContentErrorAlert;
